import { Autocomplete, Box, TextField, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { axiosPrivate } from '../../Api/axios';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
// import { TextFieldComponent } from './ReusableSmallComponents';

function SearchEntreprise({ setClient, width, name, size }) {
    SearchEntreprise.propTypes = {
        label: PropTypes.any,
        width: PropTypes.any,
        size: PropTypes.any,
        setClient: PropTypes.func,
        name: PropTypes.string,
    };
    const { inputSize } = useWindowSize();
    const { i18n } = useTranslation();
    // const role = useRole();
    const { errors, showErrors } = useUtilities();
    const error = name in errors ? errors[name] : undefined;
    const [companiesList, setCompaniesList] = React.useState([]);

    React.useEffect(() => {
        if(name)
            searchEntreprise();
    }, [name]);

    const searchEntreprise = async (event) => {
        console.log(event);
        try {
            const response = await axiosPrivate.post(`/${name}/searchEntreprise`);
            console.log(response.data);
            if(name=='client')
                setCompaniesList(response?.data?.companies);
            if(name=='esn')
                setCompaniesList(response?.data?.esns);
        } catch (error) {
            console.warn(error);
        }
    };

    return (
        <Autocomplete
            id="asynchronous-demo"
            sx={{
                width: width || 300,
                '& > :not(style)': { borderRadius: '8px' }
            }}
            getOptionLabel={(option) => `${option?.profileEntreprise?.nom}`}
            options={companiesList}
            isOptionEqualToValue={
                (option, value) => option?.profileEntreprise?.nom === value?.profileEntreprise?.nom}
            onChange={(event, newValue) => {
                setClient(newValue);
            }}
            renderOption={(props, companies) => (
                <Box
                    component='li'
                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                    {...props}
                    key={companies?._id}
                >
                    <img
                        loading="lazy"
                        width="20"
                        src={`${companies.profileEntreprise?.logo}`}
                        srcSet={`${companies.profileEntreprise?.logo}`}
                        alt=""
                    />
                    {
                        (companies?.profileEntreprise?.nom)
                    }
                </Box>
            )}
            renderInput={(params) => (
                <ThemeProvider theme={FieldComponentFont}>
                    <TextField
                        {...params}
                        sx={{
                            width: width || '350px',
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        // size={inputSize}
                        size={inputSize || size || 'medium'}
                        // placeholder={placeholder || userType}
                        // variant={variant || 'outlined'}

                        // value={city}
                        // onChange={(event) => onChangeCity(event.target.value)}

                        // label="Ville"
                        //style={{width:'353px',height:'48px',marginTop:'-5px'}}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                        }}
                        style={{ background: 'white' }}
                        name={name}
                        helperText={showErrors && (i18n.t(error) ?? '')}
                        error={!!error && showErrors}
                    />
                </ThemeProvider>
            )}
        />
    );
}

export default SearchEntreprise;